/*
    _wrap.start
*/

(function () {   //--- コーディングするコードを即時関数で囲んでスコープを切る

/**
 * prefManager.js
 */

// 都道府県
var PREF_NAME_HASH = {
  "pref_01":"北海道",
  "pref_02":"青森",
  "pref_03":"岩手",
  "pref_04":"宮城",
  "pref_05":"秋田",
  "pref_06":"山形",
  "pref_07":"福島",
  "pref_08":"茨城",
  "pref_09":"栃木",
  "pref_10":"群馬",
  "pref_11":"埼玉",
  "pref_12":"千葉",
  "pref_13":"東京",
  "pref_14":"神奈川",
  "pref_15":"新潟",
  "pref_16":"富山",
  "pref_17":"石川",
  "pref_18":"福井",
  "pref_19":"山梨",
  "pref_20":"長野",
  "pref_21":"岐阜",
  "pref_22":"静岡",
  "pref_23":"愛知",
  "pref_24":"三重",
  "pref_25":"滋賀",
  "pref_26":"京都",
  "pref_27":"大阪",
  "pref_28":"兵庫",
  "pref_29":"奈良",
  "pref_30":"和歌山",
  "pref_31":"鳥取",
  "pref_32":"島根",
  "pref_33":"岡山",
  "pref_34":"広島",
  "pref_35":"山口",
  "pref_36":"徳島",
  "pref_37":"香川",
  "pref_38":"愛媛",
  "pref_39":"高知",
  "pref_40":"福岡",
  "pref_41":"佐賀",
  "pref_42":"長崎",
  "pref_43":"熊本",
  "pref_44":"大分",
  "pref_45":"宮崎",
  "pref_46":"鹿児島",
  "pref_47":"沖縄"
};


/*
    csvLoder : CSVファイル読み込み ==========================
*/
var csvLoder = function( loadCsvUrl, debugFlag ){
    
  // インスタンスメソッド内で this代わりに使う
  var q = csvLoder.prototype;
  
  // CSV読み込みエラーを console.log に出力する場合は true (結構煩いので...)
  var DEBUGFLAG = debugFlag;
  
  var csv_data =[];
  var columnList = {};

  // ★CSVファイルを非同期でロード
  q.loadCSV = function (callback){
    $.ajax({
      url: loadCsvUrl,
      error :function(){
        q.debug('ERR: cannot load csv file. ' + loadCsvUrl);
      },
      success: function(data) {
        q.debug('LOAD: ' + loadCsvUrl);
        callback(data);
      }
    });
  },
    
  // ★各行の要素にHTMLエスケープしてArray-Objectを返却
  q.getObjectList = function( data ){
    var csv = $.csv.toObjects(data, {
      onParseValue: q.__escapeElem,
      onParseEntry: q.__rowCheck
    });
    csv_data = csv; // キャッシュ
    return csv;
  },

  // ★ 指定列のみの全行データを取得
  q.getRowdataByColumn = function(selectKey){
    var resultList = [];
    if (csv_data.length == 0) {
      return false;
    }
    for (var i = 0; i < csv_data.length; i++) {
      var rowdata = csv_data[i];
      if( rowdata[selectKey] ){
        resultList.push(rowdata[selectKey]);
      }else{
        resultList.push('');
      }
    }
    return resultList;
  },

  // -- CSV各列の値にHTMLエスケープを掛ける
  q.__escapeElem = function (value, state){
    if(value.trim().length > 0){
      return _.escape(value);
    }else{
      q.debug('ERR: detect empty R:' + state.rowNum +' C:' + state.colNum);
      return '';    // falseだとカラムがズレる
    }
  },
  
  // -- CSV各行をチェック、トリム後で空行であればスキップ
  q.__rowCheck = function(entry, state) {
    if(entry.trim().length > 0){
      q.debug('SUCCESS: ' + entry);
      return entry;
    }else{
      q.debug('ERR: detect empty Row. ' + state);
      return '';    // falseだとカラムがズレる
    }
  },

  
  // ☆ゼロサプレス処理
  q.zeroSup = function ( val ) {
    return val.replace( /^0+([0-9]+)/, "$1" );
  },
    
  // ☆デバック出力制御
  q.debug = function( outputObj ){
    if(DEBUGFLAG === true){
      console.log(outputObj);
    }
  };
  
};


// seek.js --------------------------------------------------


/*
    初期設定  ============================================
*/

// 外部リンクを target=_balnk にするスイッチ
var IS_EXTERNAL_LINK_BLANK = !(IS_SIGNAGE); // IS_SIGNAGEは他所のグローバル変数(良くない)

// VueApp.ElmID
var SEEK_APP_ELMID= "#seek__app";

// 検索モード
var SEEK_MODE_HOKKAIDO = "modeHokkaido";  // エリアで探す: 北海道
var SEEK_MODE_TOFUKEN =  "modeTofuken";   // エリアで探す: 都府県
var SEEK_MODE_YOMI =     "modeYomi";      // 五十音検索
var SEEK_MODE_INIT = SEEK_MODE_YOMI;   // 初期検索モード

// デバック出力スイッチ
var DEBUG_FLAG = false;

// 検索用キーになるカラム名
var COLUMN_KEY_AREA = 'Area';
var COLUMN_KEY_BLANCH = 'Branch';
var COLUMN_KEY_CITY = 'City';
var COLUMN_KEY_YOMI = 'Yomi';

// テーブルヘッダの表示用カラム名
var TABLE_HEADER_COLUMNS = {
  //No:         'ID',
  Order:    '掲載順',
  Area:     'エリア',
  Branch:   '支庁',
  City:     '市区町村',
  Yomi:     '市区町村読み',
  Sitename: 'サイト名',
  Url:      'サイトURL',
  Note:     '備考'
};

// 検索ボタン押下時のスクロール先
var RESULT_BTN_SCROLL_TAREGT = "#v_resultBox";

// 読み込むCSVファイルの識別: ページキャッシュ負荷を鑑みて 1時間でキャッシュクリア
var SEEK_CSV_FILEPATH = 'site_data.csv'+ '?' +
      new Date().getYear()  +
      new Date().getMonth() +
      new Date().getDay()   +
      new Date().getHours();

// エリア選択ボタン
var BTN_LIST_AREA = [];
var BTN_LIST_BRANCH = [];
var BTN_LIST_CITY = [];
var BTN_LIST_YOMI = [
  'あ行', 'か行', 'さ行', 'た行', 'な行', 'は行', 'ま行', 'や･ら･わ行'
];
var SEEK_BTN_LISTS = {};

// ボタン状態
var BTN_STATUS_SELECTED = 1;
var BTN_STATUS_HIDDEN   = 0;
var BTN_STATUS_UNSELECTED = -1;
var BTN_STATUS_DISABLE = 9;

// [五十音]検索時の検索ワード
var SEARCHWORD_LIST_YOMI = [
  'あいうえお',
  'かきくけこがぎぐげご',
  'さしすせそざじずぜぞ',
  'たちつてとだちづでど',
  'なにぬねの',
  'はひふへほばびぶべぼぱぴぷぺぽ',
  'まみむめも',
  'やゆよゃゅょらりるれろわをん'
];

/*
    ページ初期読み込み時の処理  ==================================
*/
$(function () {


  var gData = new csvLoder(SEEK_CSV_FILEPATH, DEBUG_FLAG);
  
  // CSV読み込み開始
  gData.loadCSV(function (data) {

    // 読み込んだCSVデータを加工
    var csv = gData.getObjectList(data);

    // Order列で昇順ソート
    csv.sort( _compare );

    // -- ソート関数
    function _compare(a, b) {
      var genreA = parseInt(a.Order);
      var genreB = parseInt(b.Order);
      var comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    }

    // カテゴリボタン
    BTN_LIST_AREA = _.uniq(gData.getRowdataByColumn(COLUMN_KEY_AREA));
    BTN_LIST_BRANCH = _.uniq(gData.getRowdataByColumn(COLUMN_KEY_BLANCH));
    BTN_LIST_CITY = _.uniq(gData.getRowdataByColumn(COLUMN_KEY_CITY));
    SEEK_BTN_LISTS[COLUMN_KEY_AREA] = BTN_LIST_AREA;
    SEEK_BTN_LISTS[COLUMN_KEY_BLANCH] = BTN_LIST_BRANCH;
    SEEK_BTN_LISTS[COLUMN_KEY_CITY] = BTN_LIST_CITY;
    SEEK_BTN_LISTS[COLUMN_KEY_YOMI] = BTN_LIST_YOMI;

    // Vueインスタンス生成、起動
    var vueTable = seekApp(SEEK_APP_ELMID, csv);


    // CSV読み込み後の画面描画処理
    $(window).trigger('resize');

  }); // --- gData.loadCSV

  // ☆イベント: リサイズの度にテーブルを再描画
  $(window).resize(function () {
    
  });

  // ★イベント: 『決定』ボタン押下時
  $(window).on('onClick_SearchBtn', function (ev, obj) {

    // サイト一覧のアイテムの高さを揃える
    $('.p-seekApp__resultSitelink').matchHeight();

    // スムーススクロール
    if(obj.elm && obj.elm.length > 0){
      var hashStr = obj.elm.slice(1);
      var hashElm =  $('[id='+ hashStr +']');
      var offsetTop = $(hashElm).offset().top;
      $("html,body").animate({scrollTop: offsetTop }, "slow", "swing");
    }

  });

}); // --- $(function(){



/*
  Vue.コンポーネント定義 ==================================
*/
// 選択ボタン: コンポーネント定義
var COMPONENT_TOGGLE_BTN_LIST = {
  props: ['label', 'tabidx', 'vif'],
  template: '<li v-on:click="onButtonClick()" v-if="vif"><span><button type="button" v-bind:tabindex="tabidx">{{ label }}</button></span></li>',

  methods: {
    onButtonClick: function () {
      this.$emit('toggle-button-click');
    }
  }
};




/*
  seekApp: Vue部分 ==================================
*/
var seekApp = function (elm, csvdata) {

  // Vue構築
  var appObj = new Vue({
    el: elm,
    template: '#seek__body',

    components: {
      'toggle-btn-list': COMPONENT_TOGGLE_BTN_LIST
    },


    data: function () {

      // [支庁]ボタン配列が存在: 北海道モードに切り替え
      if(SEEK_BTN_LISTS[COLUMN_KEY_BLANCH][0] !== ""){
        SEEK_MODE_INIT = SEEK_MODE_HOKKAIDO;
      }

      return {
        initMode: SEEK_MODE_INIT,             // 起動時のモード設定
        seekMode: SEEK_MODE_INIT,             // 現在のモード設定
        isFilter: false,                      // 初期表示ではフィルタしない
        seekBtnLists: SEEK_BTN_LISTS,         // カテゴリボタン配列をキャッシュ
        columnNameList: TABLE_HEADER_COLUMNS, // 表示用のカラム名
        seekBtnStatus: this._resetAllBtn(SEEK_MODE_INIT),   // ボタンを初期化
        filterColumns: [],
        rawData: csvdata,
        isExternalLinkBlank: IS_EXTERNAL_LINK_BLANK,
        resultList: [],
      };
    },

    mounted: function () {


    },

    methods: {

      /*
          pubilc method
      */
      // [mode]切り替えボタン押下時
      onClick_modeBtn: function (cMode) {
        this.seekMode = cMode;
        this.seekBtnStatus = this._resetAllBtn(cMode);
        this.filterColumns = _.clone(this.seekBtnStatus);
        this.resultList = [];
        this.isFilter = false;
      },

      // [エリア]ボタン押下時
      onClick_AreaBtn: function (cValue) {
        var newStat = this.seekBtnStatus[COLUMN_KEY_AREA][cValue] * -1;
        this.$set(  this.seekBtnStatus[COLUMN_KEY_AREA], cValue, newStat);
        if(this.seekMode === SEEK_MODE_HOKKAIDO){
          this._toggleAllChildBtn(COLUMN_KEY_AREA, COLUMN_KEY_BLANCH, cValue);
          this._hideAllChildBtn(COLUMN_KEY_AREA, COLUMN_KEY_CITY, cValue);
        }else if(this.seekMode === SEEK_MODE_TOFUKEN){
          this._toggleAllChildBtn(COLUMN_KEY_AREA, COLUMN_KEY_CITY, cValue);
        }
      },

      // [支庁]ボタン押下時
      onClick_BranchBtn: function (cValue) {
        var newStat = this.seekBtnStatus[COLUMN_KEY_BLANCH][cValue] * -1;
        this.$set(  this.seekBtnStatus[COLUMN_KEY_BLANCH], cValue, newStat);
        this._toggleAllChildBtn(COLUMN_KEY_BLANCH, COLUMN_KEY_CITY, cValue);
      },

      // [五十音]ボタン押下時
      onClick_YomiBtn: function (cValue) {
        var newStat = this.seekBtnStatus[COLUMN_KEY_YOMI][cValue] * -1;
        this.$set(  this.seekBtnStatus[COLUMN_KEY_YOMI], cValue, newStat);
        this._toggleAllChildBtn(COLUMN_KEY_YOMI, COLUMN_KEY_CITY, cValue);
      },

      // [市町村]ボタン押下時
      onClick_CityBtn: function (cValue) {
        var that = this;
        var newStat = this.seekBtnStatus[COLUMN_KEY_CITY][cValue] * -1;
        _.each(this.rawData, function (cRow, cID) {
          if(cRow[COLUMN_KEY_CITY] === cValue){
            that.$set( that.seekBtnStatus[COLUMN_KEY_CITY], cRow[COLUMN_KEY_CITY], newStat);
          }
        });
      },

      // [検索]ボタン押下時
      onClick_SearchBtn: function () {

        if (this.isSearchReady === false) {
          return false; // 検索可能でなければ押しても無反応
        }

        // 検索ボタン押下時の選択状態を filterColumns にキャッシュ
        this.isFilter = true;
        this.filterColumns = _.clone(this.seekBtnStatus);
        this.resultList = _.clone(this.filteredList);
        document.activeElement.blur();  // フォーカス残ってしまうので外す
        
        // jQuery に カスタムイベント onClick_SearchBtn を送信
        this.$nextTick(function () {
          $(window).trigger(
            new $.Event('onClick_SearchBtn'), { elm: RESULT_BTN_SCROLL_TAREGT }
          );
        });
      },

      // [リセット]ボタン押下時
      onClick_ResetBtn: function () {
        if (this.isSearchReady === false) {
          return false; // 検索可能でなければ押しても無反応
        }

        this.seekBtnStatus = this._resetAllBtn(this.seekMode);
        this.filterColumns = _.clone(this.seekBtnStatus);
        this.resultList = [];
        this.isFilter = false;
        document.activeElement.blur();  // フォーカス残ってしまうので外す
      },


      /*
          private method
      */
     
      // ボタンリセット処理
      _resetAllBtn: function(cMode){
        // ボタン状態の管理配列を生成 (-1: unselected / 0: hidden / 1: selected / 9: disable)
        var seekBtnStatus = {};
        _.each(SEEK_BTN_LISTS, function (cval, ckey) {
          seekBtnStatus[ckey] = {};
          _.each(cval, function (val, key) {
            seekBtnStatus[ckey][val] = BTN_STATUS_HIDDEN; // 初期は全て hidden
          });
        });

        //  初期表示ボタン設定: 指定モードで初期表示カラムを切り替え
        //  --- 起動時はthis.seekModeを参照できないので引数で直指定
        var startKey = "";
        switch (cMode){ 
          case SEEK_MODE_YOMI:
              startKey = COLUMN_KEY_YOMI;
              break;
          case SEEK_MODE_TOFUKEN:
              startKey = COLUMN_KEY_AREA;
              break;
          case SEEK_MODE_HOKKAIDO:
              startKey = COLUMN_KEY_AREA;
              break;
        }

        // 初期表示ボタン設定: 全て unselected
        _.each(seekBtnStatus[startKey], function (cval, ckey) {
          seekBtnStatus[startKey][ckey] = BTN_STATUS_UNSELECTED;
        });

        // 初期表示ボタン設定: 五十音: ヒット件数ゼロのボタンを disable
        _.each(seekBtnStatus[COLUMN_KEY_YOMI], function (cval, ckey) {
          if( _countDataByYomi(csvdata, ckey) === 0 ){ // 起動時も呼ぶので生データを直接
            seekBtnStatus[COLUMN_KEY_YOMI][ckey] = BTN_STATUS_DISABLE;
          }
        });

        return seekBtnStatus;
      },

      // 親ボタン押下時: 子ボタン全てを hidden / unselected
      _toggleAllChildBtn: function(parentKey, childKey, cValue){
        var that = this;
        var cStat = ( this.seekBtnStatus[parentKey][cValue] === BTN_STATUS_UNSELECTED) ?
                      BTN_STATUS_HIDDEN : BTN_STATUS_UNSELECTED;
        _.each(this.rawData, function (cRow, cID) {
          if(parentKey === COLUMN_KEY_YOMI && _isMatchYomi(cRow[COLUMN_KEY_YOMI], cValue)){
            var cCityVal = cRow[COLUMN_KEY_CITY]; // 読み配列から参照
            that.$set( that.seekBtnStatus[childKey], cCityVal, cStat);
          }else if(parentKey !== COLUMN_KEY_YOMI && cRow[parentKey] === cValue){
            that.$set( that.seekBtnStatus[childKey], cRow[childKey], cStat);
          }
        });
      },

      // 親ボタン押下時: 子ボタン全てを hidden
      _hideAllChildBtn: function(matchKey, hideKey, matchValue){
        var that = this;
        _.each(that.rawData, function (cRow, cID) {
          if(matchKey === COLUMN_KEY_YOMI && _isMatchYomi(cRow[COLUMN_KEY_YOMI], matchValue)){
            that.$set( that.seekBtnStatus[hideKey], cRow[hideKey], BTN_STATUS_HIDDEN);
          }else if(matchKey !== COLUMN_KEY_YOMI && cRow[matchKey] === matchValue){
            that.$set( that.seekBtnStatus[hideKey], cRow[hideKey], BTN_STATUS_HIDDEN);
          }
        });
      },

    }, // --- methods:

    computed: {
      
      // 検索可能な状態か? ＝市町村ボタンが一つでも選択状態
      isSearchReady: function () {
        return this.isPanelOpen_City && 
                _.contains(this.seekBtnStatus[COLUMN_KEY_CITY], BTN_STATUS_SELECTED);
      },

      // 支庁パネルOPEN ? : 指定カラムのボタン要素に hidden以外の要素があるか？
      isPanelOpen_Blanch: function(){
        return ! _isHiddenStatusAllColumnBtn(COLUMN_KEY_BLANCH, this);
      },

      // 五十音パネルOPEN ?
      isPanelOpen_Yomi: function(){
        return ! _isHiddenStatusAllColumnBtn(COLUMN_KEY_YOMI, this);
      },

      // 市町村パネルOPEN ?
      isPanelOpen_City: function(){
        return ! _isHiddenStatusAllColumnBtn(COLUMN_KEY_CITY, this);
      },

      // エリアパネルView ? : 当該パネルを指定モード時に表示させるか?
      isPanelView_Area: function(){
        return ( this.seekMode === SEEK_MODE_HOKKAIDO || this.seekMode === SEEK_MODE_TOFUKEN );
      },

      // 支庁パネルView ? 
      isPanelView_Blanch: function(){
        return ( this.seekMode === SEEK_MODE_HOKKAIDO );
      },

      // 五十音パネルView ?
      isPanelView_Yomi: function(){
        return ( this.seekMode === SEEK_MODE_YOMI );
      },

      // 市町村パネルView ?
      isPanelView_City: function(){
        return true;
      },

      // フィルタ後の行数を返却
      rowCount: function () {
        return _.size(this.resultList);
      },

      // フィルタ行を返却
      filteredList: function () {
        var data = this.rawData;
        
        // フィルタ表示させない場合は行全てを返却
        if (this.isFilter === false) {
          this.$nextTick(function () {
            $(window).trigger('resize');
          });
          return data;
        }
        
        // モードに応じてフィルタ動作を切り替え
        if(this.seekMode === SEEK_MODE_HOKKAIDO){
          data = _filterDataByColumn(COLUMN_KEY_AREA, data, this.filterColumns);
          data = _filterDataByColumn(COLUMN_KEY_BLANCH, data, this.filterColumns);
          data = _filterDataByColumn(COLUMN_KEY_CITY, data, this.filterColumns);

        }else if(this.seekMode === SEEK_MODE_YOMI){
          data = _filterDataByYomi(data, this.filterColumns);
          data = _filterDataByColumn(COLUMN_KEY_CITY, data, this.filterColumns);

        }else if(this.seekMode === SEEK_MODE_TOFUKEN){
          data = _filterDataByColumn(COLUMN_KEY_AREA, data, this.filterColumns);
          data = _filterDataByColumn(COLUMN_KEY_CITY, data, this.filterColumns);
        }

        // 行数変更後にjQuery側にresizeイベントを送信
        this.$nextTick(function () {
          $(window).trigger('resize');
        });

        return data;
      }
    } // --- computed:

  }); // --- appObj


  /*
      サブルーチン: computedで使用するので method に入れられない処理
  */

  // 五十音: フィルタ処理
  function _filterDataByYomi(rdata, filterColumns){
    var columnName = COLUMN_KEY_YOMI;
    var retData = [];
    var fclist = filterColumns[columnName];
    if (fclist) {
      retData = rdata.filter(function (row) {
        return _.keys(fclist).some(function (key) {
          if (fclist[key] === BTN_STATUS_SELECTED) {
            return _isMatchYomi( String(row[columnName]) , key);
          }
        });
      });
    }
    return retData;
  }

  // 五十音: ヒット件数
  function _countDataByYomi(rdata, btnLabel){
    var retData = [];
    retData = rdata.filter(function (row) {
      return _isMatchYomi(String(row[COLUMN_KEY_YOMI]), btnLabel);
    });
    return retData.length;
  }

  // 五十音: ボタンmatch :"かな行"の検索文字列の中に[サイト名読み]の先頭1文字が含まれるかをチェック
  function _isMatchYomi(rowYomi, btnLabel){
    var testStr = String(rowYomi).slice( 0, 1 ); //先頭1文字を切り出す
    var hitIdx = _.indexOf(BTN_LIST_YOMI, btnLabel);
    var seekStr = String(SEARCHWORD_LIST_YOMI[hitIdx]);
    return ( seekStr.indexOf(testStr) !== -1);
  }
  
  // カラム別絞り込み
  function _filterDataByColumn(columnName, rdata, filterColumns){
    var retData = [];
    var fclist = filterColumns[columnName];
    if (fclist) {
      retData = rdata.filter(function (row) {
        return _.keys(fclist).some(function (key) {
          if (fclist[key] === BTN_STATUS_SELECTED && String(row[columnName]) === key) {
            return true;
          }
        });
      });
    }
    return retData;
  }

  // 指定カラムのボタンが全て hidden であるかをチェック
  function _isHiddenStatusAllColumnBtn(childKey, that){
    return _.every( that.seekBtnStatus[childKey], function(val){ return val === BTN_STATUS_HIDDEN; });
  }

  return appObj;
};


})();  //--- 即時関数によるスコープ: 終了

/*
    _wrap.end
*/
